/* Nuvò · Carrello — quantità, rimozione, «Aggiungi» e aggiornamento della sezione senza ricaricare la pagina */
(function () {
  'use strict';
  if (window.__nuvoCart) { return; }
  window.__nuvoCart = true;

  var busy = false;
  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function post(path, body) {
    return fetch(base + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) { throw new Error('HTTP ' + res.status); }
      return res.json();
    });
  }

  function saveNote() {
    var t = document.querySelector('[data-nc-note]');
    if (!t) { return Promise.resolve(); }
    return post('cart/update.js', { note: t.value }).catch(function () {});
  }

  // Aggiorna il numerino del carrello nell'header (prova i nomi più comuni dei temi)
  function updateHeader() {
    fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = String(cart.item_count);
        var sel = '[data-cart-count],.cart-count-bubble span[aria-hidden="true"],.cart-count-bubble,#CartCount,.cart-count,.header__cart-count';
        document.querySelectorAll(sel).forEach(function (el) {
          if (el.closest('[data-nc-root]')) { return; }
          if (/^\s*\d+\s*$/.test(el.textContent)) { el.textContent = n; }
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
      })
      .catch(function () {});
  }

  function refresh(focusSel) {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-nc-root]'));
    if (!roots.length) { window.location.reload(); return Promise.resolve(); }
    return Promise.all(roots.map(function (root) {
      var id = root.getAttribute('data-nc-section');
      return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), { headers: { 'Accept': 'text/html' } })
        .then(function (res) {
          if (!res.ok) { throw new Error('HTTP ' + res.status); }
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-nc-root]');
          if (!next) { throw new Error('no root'); }
          return { root: root, next: next };
        });
    })).then(function (pairs) {
      pairs.forEach(function (x) {
        // i bottoni rapidi li prepara lo script di Shopify al caricamento: li teniamo, invece di sostituirli con una copia vuota
        var oldEx = x.root.querySelector('[data-nc-express]'), newEx = x.next.querySelector('[data-nc-express]');
        if (oldEx && newEx) { newEx.replaceWith(oldEx); }
        else if (newEx && !oldEx) { window.location.reload(); }
        x.root.replaceWith(x.next);
      });
      if (focusSel) {
        var f = document.querySelector(focusSel);
        if (f && !f.disabled) { f.focus(); }
      }
      updateHeader();
    });
  }

  function run(job, focusSel) {
    if (busy) { return; }
    busy = true;
    var root = document.querySelector('[data-nc-root]');
    if (root) { root.setAttribute('aria-busy', 'true'); }
    saveNote()
      .then(job)
      .then(function () { return refresh(focusSel); })
      .catch(function () { window.location.reload(); })
      .then(function () { busy = false; });
  }

  function keySel(act, key) {
    return '[data-nc-act="' + act + '"][data-key="' + String(key).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]';
  }

  function setQty(key, qty) {
    qty = Math.max(0, Math.min(99, qty));
    run(function () { return post('cart/change.js', { id: key, quantity: qty }); }, qty > 0 ? keySel('inc', key) : null);
  }

  // FAQ: il bottone «+» mostra o nasconde l'elenco delle domande
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-nc-faq-all]') : null;
    if (!b) { return; }
    var list = b.closest('.nc-faq').querySelector('[data-nc-faq-list]');
    var open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (list) { list.hidden = open; }
  });

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-nc-act]');
    if (!el || !el.closest('[data-nc-root]')) { return; }
    var act = el.getAttribute('data-nc-act');
    var key = el.getAttribute('data-key');
    if (act === 'add') {
      e.preventDefault();
      var variant = parseInt(el.getAttribute('data-variant'), 10);
      if (!variant) { return; }
      run(function () { return post('cart/add.js', { id: variant, quantity: 1 }); });
      return;
    }
    var input = document.querySelector('[data-nc-qty][data-key="' + String(key).replace(/"/g, '\\"') + '"]');
    var cur = input ? parseInt(input.value, 10) || 1 : 1;
    if (act === 'inc') { e.preventDefault(); setQty(key, cur + 1); }
    if (act === 'dec') { e.preventDefault(); setQty(key, cur - 1); }
    if (act === 'remove') { e.preventDefault(); setQty(key, 0); }
  });

  document.addEventListener('change', function (e) {
    var q = e.target.closest ? e.target.closest('[data-nc-qty]') : null;
    if (q && q.closest('[data-nc-root]')) {
      setQty(q.getAttribute('data-key'), parseInt(q.value, 10) || 0);
      return;
    }
    if (e.target.matches && e.target.matches('[data-nc-note]')) { saveNote(); }
  });

  // Invio con il tasto Invio dentro il campo quantità: aggiorna senza passare dal checkout
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-nc-qty]')) {
      e.preventDefault();
      setQty(e.target.getAttribute('data-key'), parseInt(e.target.value, 10) || 0);
    }
  });
})();
